/**
 * @desc 根据来源标识与文件类型查找附件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.AssociatedFilesResponseDto>>;
export function request(
  params: API.basics.associatedFilesFacadeImpl.getBySourceIdAndType.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/getBySourceIdAndType`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
